class Checkall {
    elCheckbox:  HTMLInputElement;
    elTargets:   NodeListOf<HTMLInputElement>;

    afterChange: ((changed: Array<HTMLInputElement>) => void)

    constructor(el: HTMLInputElement, targets: NodeListOf<HTMLInputElement>, opts: any) {
        this.elCheckbox = el;
        this.elTargets  = targets;

        this.afterChange = opts.afterChange || this.defaultAfterChange;

        this.init();
    }

    defaultAfterChange(changed: Array<HTMLInputElement>) {
        changed.forEach((el) => {
            const e = new Event("change");

            el.dispatchEvent(e);
        })
    }

    init() {
        this.refreshState();

        this.elTargets.forEach((el) => {
            el.addEventListener("change", (e) => {
                this.refreshState();
            })
        })

        this.elCheckbox.addEventListener("change", (e) => {
            let changed: Array<HTMLInputElement> = [];

            if (this.elCheckbox.checked) {
                // Check all
                this.elTargets.forEach((el) => {
                    if (!el.checked) {
                        el.checked = true;
                        changed.push(el);
                    }
                })
            } else {
                // Uncheck all
                this.elTargets.forEach((el) => {
                    if (el.checked) {
                        el.checked = false;
                        changed.push(el);
                    }
                })
            }

            this.afterChange(changed);
        })
    }

    refreshState() {
        let selected = 0;
        
        this.elTargets.forEach((e) => {
            if (e.checked) {
                selected++;
            }
        });

        let total = this.elTargets.length;

        if (selected == 0) {
            this.elCheckbox.checked = false;
            this.elCheckbox.indeterminate = false;
        } else if (selected == total) {
            this.elCheckbox.checked = true;
            this.elCheckbox.indeterminate = false;
        } else {
            this.elCheckbox.checked = true;
            this.elCheckbox.indeterminate = true;
        }

    }
}

export { Checkall };